import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ImporterService } from '../importer.service';
import { LocalizationService } from '../../services/localization.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { WSImport } from '../import.models';
import { EnvironmentService } from '../../services/environment.service';

@Component({
    selector: 'app-pg-import-job',
    templateUrl: './pg-import-job.component.html',
    styleUrls: ['./pg-import-job.component.scss'],
    standalone: false
})
export class PgImportJobComponent implements OnInit, OnDestroy {

    constructor(private environmentService:EnvironmentService, private localizationService:LocalizationService, private importerService:ImporterService, private modalService:NgbModal) { }

    @Input() job:WSImport.Job;
    @Input() APIUrlOptions:Array<{ value: string, text: string, realms?: Array<string|number> }>;

    @Output() cancel = new EventEmitter<void>()

    showDetails:{ [status:string]: boolean } = {};

    ngOnInit() {
    }

    ngOnDestroy() {
        if(this.errorModalResponseFile != null) URL.revokeObjectURL(this.errorModalResponseFile)
    }

    getImportTypeIcon(type) {
        switch(type) {
            case 'entourance': return 'fa-regular fa-server';
            case 'file': return 'fa-regular fa-file-spreadsheet';
            case 'wordpress': return 'fa-brands fa-wordpress';
            case 'dhm': return 'fa-regular fa-gears';
            case 'eppoi': return 'fa-regular fa-map-location-dot';
        }
    }

    getRealmName(realm:string) {
        return this.environmentService.getRealmName(realm)
    }

    translateResource(resource:string) {
        if(resource != null) {
            let _split = resource.split(',')
            let _result = ''

            for(let _item of _split) {
                if(_result != '') _result += ', '
                _result += this.localizationService.translateResource(_item)
            }

            return _result;
        }
    }

    formatDateTime(val:string) {
        return this.localizationService.format.datetime(val, true)
    }

    formatDate(val:string) {
        return this.localizationService.format.date(val)
    }

    formatTime(val:string) {
        return this.localizationService.format.time(val, true)
    }

    isStatusFinished(status:string) {
        return status == 'success' || status == 'success_secondary_errors' || status == 'error' || status == 'update' || status == 'canceled'
    }

    getProgressStatusColor(status:string) {
        switch(status) {
            case 'success': return 'success';
            case 'success_secondary_errors': return 'warning';
            case 'error': return 'danger';
            case 'update': return 'primary';
            case 'progress': return 'primary';
            case 'waiting': return 'muted';
            case 'canceled': return 'muted';
        }
    }

    getProgressStatusIcon(status:string) {
        switch(status) {
            case 'success': return 'fa-square-check';
            case 'success_secondary_errors': return 'fa-square-check';
            case 'error': return 'fa-circle-exclamation';
            case 'update': return 'fa-arrows-rotate';
            case 'progress': return 'fa-clock';
            case 'waiting': return 'fa-hourglass';
            case 'canceled': return 'fa-times';
        }
    }

    getProgressFinishedTotal(progress:WSImport.JobProgress, justMain?:boolean) {
        let _result = {
            total: 0,
            finished: 0
        }

        if(progress.tasks != null) {
            _result.total++;
            if(progress.time_end || this.isStatusFinished(progress.tasks.main.status)) _result.finished++;

            if(!justMain) {
                if(progress.tasks.translations != null) {
                    for(let _task of progress.tasks.translations) {
                        _result.total++;
                        if(progress.time_end || this.isStatusFinished(_task.status)) _result.finished++;
                    }
                }
    
                if(progress.tasks.files != null) {
                    for(let _task of progress.tasks.files) {
                        _result.total++;
                        if(progress.time_end || this.isStatusFinished(_task.status)) _result.finished++;
                    }   
                }
            }
        }

        return _result;
    }

    getProgressBarTransform(progress:WSImport.JobProgress) {
        if(progress.tasks?.translations == null) {
            return 'translate(-100%, 1)'
        }
        else {
            let _status = this.getProgressFinishedTotal(progress)
    
            return 'translate(' + (10 + _status.finished / _status.total * 90 - 100) + '%, 0)'
        }
    }

    getJobTimeBegin() {
        if(this.job.progress != null && this.job.progress.length > 0) return this.job.progress[0].time_begin;
    }

    getJobTimeEnd() {
        if(this.job.progress != null && this.job.progress.length > 0) return this.job.progress[this.job.progress.length - 1].time_end;
    }

    getJobFinishedTotal() {
        let _result = {
            total: 0,
            finished: 0
        }

        for(let _progress of this.job.progress) {
            _result.total++;

            let _status = this.getProgressFinishedTotal(_progress)

            if(_status.total != 0) {
                _result.finished += (_status.finished / _status.total);
            }
        }

        return _result;
    }

    getJobBarTransform() {
        let _status = this.getJobFinishedTotal();

        return 'translate(' + (_status.finished / _status.total * 100 - 100) + '%, 0)'
    }

    getProgressStatus(progress:WSImport.JobProgress) {
        let _status:string = progress.status;

        if(_status == 'success' && this.hasSecondaryErrors(progress)) {
            return 'success_secondary_errors'
        }
        else {
            return _status
        }
    }

    private _jobResultsTotals = {
        success: 0,
        success_secondary_errors: 0,
        update: 0,
        error: 0,
        progress: 0,
        waiting: 0,
        canceled: 0
    }

    getJobResult() {
        for(let i in this._jobResultsTotals) {
            this._jobResultsTotals[i] = 0;
        }

        for(let _progress of this.job.progress) {
            let _status = this.getProgressStatus(_progress);

            if(typeof this._jobResultsTotals[_status] == 'number') {
                this._jobResultsTotals[_status]++;
            }
            else {
                if(_progress.time_begin) {
                    this._jobResultsTotals.progress++;
                }
                else {
                    this._jobResultsTotals.waiting++;
                }
            }
        }

        return this._jobResultsTotals
    }

    // NB: questo non è proprio pulito

    isJobInitializing() {
        for(let i in this._jobResultsTotals) {
            if(this._jobResultsTotals[i] > 0) return false;
        }

        return true;
    }

    @ViewChild('errorModal') errorModal:ElementRef

    errorModalLoading = false;
    errorModalResponseData:any = null;
    errorModalResponseFile:string = null;

    private _errorModalRef:NgbModalRef = null;

    openError(job:WSImport.Job, progress:number, task:string, index?:number) {

        if(this.errorModalResponseFile != null) URL.revokeObjectURL(this.errorModalResponseFile)

        this.errorModalLoading = true;
        this.errorModalResponseFile = null;
        this.errorModalResponseData = null;

        this._errorModalRef = this.modalService.open(this.errorModal, { size: 'xl', modalDialogClass: 'PGImportJob-ErrorModal' })

        this.importerService.getError(job, progress, task, index).subscribe((data) => {
            this.errorModalLoading = false;
            let _data = JSON.parse(JSON.stringify(data))

            if(_data.body) {
                try {
                    _data.body = JSON.parse(_data.body);
                }
                catch(ex) {}
            }

            if(_data.response) {
                this.errorModalResponseFile = URL.createObjectURL(new Blob([_data.response]))
                delete _data.response;
            }

            this.errorModalResponseData = _data;
        }, () => {
            this.errorModalLoading = false;
        })
    }

    errorModalDismiss() {
        this._errorModalRef.dismiss()
    }

    getEntouranceJob(job:WSImport.Job) {
        if(job.type == 'entourance') return job;
    }

    getFileJob(job:WSImport.Job) {
        if(job.type == 'file') return job;
    }

    getWordPressJob(job:WSImport.Job) {
        if(job.type == 'wordpress') return job;
    }

    getDHMJob(job:WSImport.Job) {
        if(job.type == 'dhm') return job;
    }

    getEPPOIJob(job:WSImport.Job) {
        if(job.type == 'eppoi') return job;
    }

    formatFileJobItem(item:any) {
        let _item = JSON.parse(JSON.stringify(item))

        for(let _prop of ['imported','user_id','realm_id']) {
            if(typeof _item[_prop] != 'undefined') delete _item[_prop]
        }

        return JSON.stringify(_item, null, 4)
    }

    hasSecondaryErrors(progress:WSImport.JobProgress) {
        if(progress.tasks) {
            if(progress.tasks.translations != null) {
                for(let _task of progress.tasks.translations) {
                    if(_task.status == 'error') return true;
                }
            }

            if(progress.tasks.files != null) {
                for(let _task of progress.tasks.files) {
                    if(_task.status == 'error') return true;
                }
            }
        }
    }

    getJobItemListDisplay(items:Array<WSImport.JobItem>, secondary?:boolean) {
        let _result = ''

        let _lastResource = null;

        for(let _item of items) {
            if((secondary && _item.secondary) || (!secondary && !_item.secondary)) { // NB: qua una semplice uguaglianza non basta
                if(_result != '') _result += ', '
                if(_item.resource != _lastResource) {
                    _result += this.translateResource(_item.resource) + ' - '
                }
    
                _result += (_item.id || '');
                _lastResource = _item.resource;
            }
        }

        return _result
    }

    getElementURL(resource:string, element:string) {
        return this.environmentService.getApplicationURL('Entourance') + '/dms/resource/' + resource + '/-/' + element + '/view';
    }

    getImportInstallationName(url:string) {
        if(this.APIUrlOptions != null) {
            for(let _item of this.APIUrlOptions) {
                if(_item.value == url) return _item.text;
            }
        }
    }
}
